import { Util } from '@/utils/util';
import {Component, OnInit} from '@angular/core';
import {AppService} from '@services/app.service';
import { AuthService } from '@services/auth/auth.service';
import {DateTime} from 'luxon';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
    public user;

    constructor(private appService: AppService,private authService: AuthService, private util: Util) {
        this.user = this.appService.getProfile();
    }

    ngOnInit(): void {
        
    }

    logout() {
        this.authService.logoutRemoto();
            this.util.successMessage('Sesión cerrada correctamente.');
    }

    formatDate(date) {
        return DateTime.fromISO(date).toFormat('dd LLL yyyy');
    }
}
